module.exports = __webpack_public_path__ + "img/6.9a9419e3.png";